import React from 'react';
import PropTypes from 'prop-types';
import {GenericButton} from "../../../components/buttons/customButtons";
import {TT_UPD_PRICES} from "../../../components/i18n/toolTips";


function PromotionItem(props) {
    const {item, index, onEdit, onEditProducts, onUpdatePrices} = props;

    const onClick = () => {
        onEdit(item);
    }

    return (
        <div id={'promotion-item'} key={'promotion-item-' + index} className={'promotion-item'} >
            <h3 className="code" onClick={onClick}>{item?.code}</h3>
            <img className={'image' + (!item?.status ? ' grayscale' : '')} src={item?.mediaUrl} alt={item?.code} onClick={onClick}/>
            <h4 className="code" onClick={onClick}>{'Cupon: ' + (item?.coupon || '')}</h4>
            <div className={'top-right-fixed'}>
                <GenericButton
                    style={'table'}
                    toolTip={TT_UPD_PRICES}
                    icon={'fa-dollar-sign'}
                    permission={'prices'}
                    onClick={_ => onUpdatePrices(item)}/>

                <GenericButton
                    style={'table'}
                    toolTip={'Productos'}
                    icon={'fa-box-open'}
                    permission={'search'}
                    onClick={_ => onEditProducts(item, index)}/>
            </div>
        </div>
    );
}

PromotionItem.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
};

export default PromotionItem;